import { OrganisationIdAndName } from '@/types/organisation';
import { Unit } from '@/types/unit';
import { organisationIdAndNameOnly } from './organisation-id-and-name-only';

export const updateUnitWithOrganisation = <TUnit extends Partial<Unit>>(
  unit: TUnit,
  organisation: OrganisationIdAndName,
): TUnit & Pick<Unit, 'organisation'> => ({
  ...unit,
  organisation: organisationIdAndNameOnly(organisation),
});
